import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import eventType from "../../../prop-types/eventType";
import { TextInput } from "../../../commons/formik";
import { USER, LOGIN } from "../../../constants";
import { requestPasswordReset } from "../../../state/user/actions";
import { Template, ButtonContainer, Button } from "../../../commons/elements";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  // Map state to props
  isSubmitting: PropTypes.bool.isRequired,
  // Map dispatch to props
  requestPasswordResetAction: PropTypes.func.isRequired
};

export function RecoverPassword(props) {
  const { types, isSubmitting, requestPasswordResetAction } = props;
  const [email, setEmail] = useState("");
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  const onSubmit = (values) => {
    setEmail(values.email);
    requestPasswordResetAction({
      ...values,
      history,
      location,
      shortName: params.shortName
    });
  };

  const formikForm = (
    <Formik
      initialValues={{
        email
      }}
      validationSchema={Yup.object({
        email: Yup.string()
          .email("Invalid email address")
          .required("Please enter a valid email")
      })}
      onSubmit={onSubmit}
    >
      {({ isValid, dirty }) => (
        <Form>
          <p>
            Please enter your email address and click Confirm. You will receive
            an email with instructions to reset your password. Your password
            will not be changed until you have completed the process outlined in
            the email.
          </p>
          <div>
            <TextInput
              id="edit-personal-info-email"
              label="Email"
              name="email"
              type="email"
              placeholder="example@email.com"
              labelProps={{ className: "lbl-email" }}
            />
          </div>
          <ButtonContainer>
            <Button
              label="Cancel"
              className="cancel-btn"
              onClick={() => {
                history.push(`/${params.shortName}/${LOGIN}${location.search}`);
              }}
            />
            <Button
              type="submit"
              label="Confirm"
              disabled={!(isValid && dirty) || isSubmitting}
              isSubmitting={isSubmitting}
            />
          </ButtonContainer>
        </Form>
      )}
    </Formik>
  );

  return (
    <Template header="Forgot Password" tabName={USER} types={types}>
      {formikForm}
    </Template>
  );
}

RecoverPassword.propTypes = propTypes;

const mapStateToProps = (state) => ({
  isSubmitting: state.user.isSubmitting
});

const mapDispatchToProps = {
  requestPasswordResetAction: requestPasswordReset
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);
